var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex f-center f-j-center displayer-img" },
    [
      [
        _c("img", {
          staticClass: "blinki-hide",
          attrs: { src: _vm.Bg_path },
          on: {
            error: function ($event) {
              return _vm.hasError()
            },
          },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "image-box",
          class: { "path-error": _vm.haveError },
          style: {
            backgroundSize: "auto",
            backgroundImage: "url(" + _vm.Bg_path + "), url(/images/demo.jpg)",
          },
        }),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }